module.exports = __webpack_public_path__ + "fonts/SteelfishRg-Bold.07a92d87.woff2";